import AppLayout from '@/layouts/AppLayout.vue';

import PersonalizeRoutes from '@/router/routes/w2p/personalize.route';
import ProjectsRoutes from '@/router/routes/w2p/projects.route';
import TemplatesBlocksRoutes from '@/router/routes/w2p/templates-blocks.route';

const routes = [
  {
    path: '/w2p',
    component: AppLayout,
    meta: { auth: true },
    children: [PersonalizeRoutes, ProjectsRoutes, TemplatesBlocksRoutes]
  }
];

export default routes;
